import { db } from "@workspace/db";
import { activityEventsTable, auditLogTable } from "@workspace/db";

interface ActivityParams {
  companyId: number;
  userId?: number;
  userName?: string;
  action: string;
  entityType?: string;
  entityId?: number;
  entityTitle?: string;
}

export async function logActivity(params: ActivityParams) {
  try {
    await db.insert(activityEventsTable).values({
      companyId: params.companyId,
      userId: params.userId,
      userName: params.userName,
      action: params.action,
      entityType: params.entityType,
      entityId: params.entityId,
      entityTitle: params.entityTitle,
    });
  } catch {
    // Non-fatal
  }
}

interface AuditParams {
  userId?: number;
  userEmail?: string;
  companyId?: number;
  tenderId?: number;
  action: string;
  entityType: string;
  entityId?: number;
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
}

export async function logAudit(params: AuditParams) {
  try {
    await db.insert(auditLogTable).values({
      userId: params.userId,
      userEmail: params.userEmail,
      companyId: params.companyId,
      tenderId: params.tenderId,
      action: params.action,
      entityType: params.entityType,
      entityId: params.entityId,
      before: params.before,
      after: params.after,
    });
  } catch {
    // Non-fatal
  }
}
